import { render, staticRenderFns } from "./ImageWithDetail.vue?vue&type=template&id=b9c79772&scoped=true&"
import script from "./ImageWithDetail.vue?vue&type=script&lang=js&"
export * from "./ImageWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithDetail.vue?vue&type=style&index=0&id=b9c79772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c79772",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
